export default "__VITE_ASSET__CbLT4Lok__"